import { BaseService } from "../../core/baseService";
import { ApiResult } from "../../core/types";
import {
  LateCheckoutSettingsDto,
  UpdateLateCheckoutSettingsDto,
  LateCheckoutOptionDto,
  CreateLateCheckoutOptionDto,
  UpdateLateCheckoutOptionDto,
} from "../types/lateCheckoutSettings.types";
import { OccupancySnapshotDto } from "../types/occupancy.types";

export interface LateCheckoutSettingsServiceInterface {
  getSettings(): Promise<ApiResult<LateCheckoutSettingsDto>>;
  updateSettings(
    settings: UpdateLateCheckoutSettingsDto
  ): Promise<ApiResult<LateCheckoutSettingsDto>>;
  getOptions(): Promise<ApiResult<LateCheckoutOptionDto[]>>;
  createOption(
    option: CreateLateCheckoutOptionDto
  ): Promise<ApiResult<LateCheckoutOptionDto>>;
  updateOption(
    optionId: string,
    option: UpdateLateCheckoutOptionDto
  ): Promise<ApiResult<LateCheckoutOptionDto>>;
  deleteOption(optionId: string): Promise<ApiResult<void>>;
  getOccupancyPreview(): Promise<ApiResult<OccupancySnapshotDto>>;
}

export class LateCheckoutSettingsService
  extends BaseService
  implements LateCheckoutSettingsServiceInterface
{
  async getSettings(): Promise<ApiResult<LateCheckoutSettingsDto>> {
    return this.handleRequest<LateCheckoutSettingsDto>(
      this.client.get("/api/admin/late-checkout-settings")
    );
  }

  async updateSettings(
    settings: UpdateLateCheckoutSettingsDto
  ): Promise<ApiResult<LateCheckoutSettingsDto>> {
    return this.handleRequest<LateCheckoutSettingsDto>(
      this.client.put("/api/admin/late-checkout-settings", settings)
    );
  }

  async getOptions(): Promise<ApiResult<LateCheckoutOptionDto[]>> {
    return this.handleRequest<LateCheckoutOptionDto[]>(
      this.client.get("/api/admin/late-checkout-settings/options")
    );
  }

  async createOption(
    option: CreateLateCheckoutOptionDto
  ): Promise<ApiResult<LateCheckoutOptionDto>> {
    return this.handleRequest<LateCheckoutOptionDto>(
      this.client.post("/api/admin/late-checkout-settings/options", option)
    );
  }

  async updateOption(
    optionId: string,
    option: UpdateLateCheckoutOptionDto
  ): Promise<ApiResult<LateCheckoutOptionDto>> {
    return this.handleRequest<LateCheckoutOptionDto>(
      this.client.put(
        `/api/admin/late-checkout-settings/options/${optionId}`,
        option
      )
    );
  }

  async deleteOption(optionId: string): Promise<ApiResult<void>> {
    return this.handleRequest<void>(
      this.client.delete(`/api/admin/late-checkout-settings/options/${optionId}`)
    );
  }

  async getOccupancyPreview(): Promise<ApiResult<OccupancySnapshotDto>> {
    return this.handleRequest<OccupancySnapshotDto>(
      this.client.get("/api/admin/occupancy/preview")
    );
  }
}
